#import "@/apollo/fragments/Client.gql"

mutation UpdateClient(
    $clientId: ID!
    $content: String!
    $name: String
    $imageProcessingEnabled: Boolean
    $fbAdsManagerConfig: InputFacebookAdsManagerConfig
    $connectModuleEnabled: Boolean
    $creativeXPlatformSettings: InputCreativeXPlatformSettings
    $sataliaPlatformSettings: InputSataliaPlatformSettings
) {
    updateClient(
        clientId: $clientId
        content: $content
        name: $name
        imageProcessingEnabled: $imageProcessingEnabled
        fbAdsManagerConfig: $fbAdsManagerConfig
        connectModuleEnabled: $connectModuleEnabled
        creativeXPlatformSettings: $creativeXPlatformSettings
        sataliaPlatformSettings: $sataliaPlatformSettings
    ) {
        ...Client
        fbAdsManagerConfig {
            businessId
            adAccountId
        }
        creativeXPlatformSettings {
            enabled
            brandId
            threshold
        }
        sataliaPlatformSettings {
            enabled
            domain
        }
    }
}
